import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    gap: ${({ theme }) => theme.spacing[4]};
`;

export const RestaurantWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const RestaurantText = styled.p`
    font-size: ${({ theme }) => theme.font.size.normal};
`;

export const ButtonWrapper = styled.div`
    width: 120px;
`;

export const EmptyMessage = styled.p`
    font-size: ${({ theme }) => theme.font.size.normal};
    color: ${({ theme }) => theme.color.grey500};
`;
